import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadScrumb from "../components/BreadScrumb";
import { Link, useParams } from "react-router-dom";
import { GetAllColor } from "../apis/Api";
import { Loader } from "../common/Loader";

const ColorPage = () => {
  const { model_token } = useParams();
  const [colors, setColors] = useState([]);
  const [filteredColors, setFilteredColors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllColors = async () => {
      setLoading(true);
      try {
        const response = await GetAllColor(model_token);
        if (response) {
          setColors(response.data);
          setFilteredColors(response.data);
        }
      } catch (error) {
        console.log("Error fetching colors", error);
        setError("Coming Soon");
      } finally {
        setLoading(false);
      }
    };

    fetchAllColors();
  }, [model_token]);

  useEffect(() => {
    const filtered = colors.filter((color) =>
      color.color_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredColors(filtered);
  }, [searchTerm, colors]);

  return (
    <div>
      <Header />
      <div id="content" className="no-top no-bottom">
        <BreadScrumb title="Select Color" Banner="/assets/images/background/3.webp" />
        <section className="responsive-section all-container marginBottom">
  <div className="container green-color">
    <div className="mb-4 text-center">
      <input
        type="text"
        placeholder="Search Color..."
        className="form-control w-50 mx-auto"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>

    {loading && (
      <div className="row">
        <div className="col-md-12 d-flex justify-content-center">
          <Loader />
        </div>
      </div>
    )}

    {!loading && error && <h5 className="text-center">{error}</h5>}

    {!loading && !error && (
      <div className="row text-center d-flex">
        {filteredColors.length > 0 ? (
          filteredColors.map((data, index) => (
            <Link
              key={index}
              to={`/inventory/${data.brand_token}/${data.model_token}/${data.color_token}?color=${data.color_name}`}
              className="col-lg-2 col-md-4 col-sm-6 col-4 mb-4 p-2"
            >
              <div
                className="shadow brand-col d-flex flex-column align-items-center"
                style={{
                  cursor: "pointer",
                  padding: "15px",
                  borderRadius: "10px",
                  background: "#fff",
                  transition: "all 0.3s ease",
                  textAlign: "center",
                  width: "100%",
                  height: "140px", 
                  overflow: "hidden",
                }}
              >
                <img
                  src={data.url}
                  alt={data.color_name}
                  className="brand-img"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "contain",
                  }}
                />
                <h6
                  className="brand-text mt-2 text-wrap"
                  style={{
                    fontSize: "14px",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2, 
                  }}
                >
                  {data.color_name}
                </h6>
              </div>
            </Link>
          ))
        ) : (
          <h5 className="text-center">No Colors Found</h5>
        )}
      </div>
    )}
  </div>
</section>

      </div>
      <Footer />
    </div>
  );
};

export default ColorPage;
